export const getStatusBadgeClass = (status) => {
  switch (status) {
    case "ACTIVE":
    case "COMPLETED":
    case "OPEN":
    case "PAID":
    case "POSSIBLE":
    case "PROCESSED":
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300";
    case "REFUNDED":
      return "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300";
    case "NOT_SUPPORTED_SOLUTION":
    case "DEACTIVE":
    case "CANCELED":
    case "CLOSED":
    case "UNPAID":
    case "NOT_POSSIBLE":
      return "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300";
    case "PENDING":
    case "IN_PROGRESS":
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300";
  }
};

export const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
};
